import mod from "-!./AShare.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./AShare.js?vue&type=script&lang=js&external"